import React from 'react'
import PractitionersSearchCard from './componenets/PractitionersSearchCard'
import TopSearchSpecialties from './componenets/TopSearchSpecialties'
import NearbyHospitals from 'pages/Referals/Components/Common/widgets/NearbyHospitals'
import PeopleKnowWidgetBasisOfLocation from 'pages/Referals/Components/Common/widgets/PeopleKnowWidgetBasisOfLocation'
import PractitionerProfiles from './componenets/PractitionerProfiles'
import { useState } from 'react'
import { PractitionerService } from 'utils/PractitionerService'
import { FAILED_TO_FETCH_DATA } from 'utils/Constants'

export default function PatientHome() {
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [contents, setContents] = useState([]);
  const [initialValues, setInitialValues] = useState({
    name: "",
    city: [],
    primarySpeciality: [],
  });
  const [query, setQuery] = useState("");
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [showProfiles, setShowProfiles] = useState(false);

  const makeQuery = (name, city, primarySpeciality) => {
    let query = "";
    if (name !== "") {
      query = `(na=="*${encodeURIComponent(name)}*")`;
    }

    if (city !== "") {
      if (query === "") query = `(ci=="${encodeURIComponent(city)}")`;
      else query += `;(ci=="${encodeURIComponent(city)}")`;
    }

    if (primarySpeciality !== "" && primarySpeciality !== undefined) {
      if (query === "") query = `(ps=="${encodeURIComponent(primarySpeciality)}")`;
      else query += `;(ps=="${encodeURIComponent(primarySpeciality)}")`;
    }

    return query;
  }

  const fetchProfileData = (values) => {
    setIsLoading(true);
    setShowProfiles(true);
    let sq = "";
    if (values !== "") {
      sq = makeQuery(
        values?.name ? values?.name : "",
        (values?.city && values?.city.length > 0) ? values?.city[0].value.split(", ")[0] : "",
        values?.primarySpeciality ? values?.primarySpeciality[0] : ""
      );
    }
    setQuery(sq);

    PractitionerService.getAllProfiles(sq, 0)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          setContents(data?.contents);
          setCurrentPage(data?.currentPage)
          setHasMore((data?.currentPage + 1) < data?.totalPages);
          setIsLoading(false);
        } else {
          console.log(FAILED_TO_FETCH_DATA)
          setIsLoading(false);
        }
      })
  }

  const fetchMoreProfileData = () => {
    setLoadingMore(true);
    PractitionerService.getAllProfiles(query, currentPage + 1)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          setContents((contents) => [...contents, ...data?.contents]);
          setCurrentPage(data?.currentPage)
          setLoadingMore(false);
        } else {
          setLoadingMore(false);
          console.log(FAILED_TO_FETCH_DATA)
        }
      })
  }

  const handleCardClick = (specilaity) => {
    fetchProfileData({ primarySpeciality: specilaity.split(", ") })
  }

  const handleFilter = (values) => {
    fetchProfileData(values);
  };


  return (
    <div>
      <PractitionersSearchCard
        initialValues={initialValues}
        handleFilter={handleFilter}
      />
      <div className='nex-flex nex-main-area-wrap align-items-start'>
        <div className="left-content">
          {showProfiles ?
            <PractitionerProfiles
              isLoading={isLoading}
              contents={contents}
              hasMore={hasMore}
              loadingMore={loadingMore}
              fetchMoreProfileData={fetchMoreProfileData}
            />
            :
            <TopSearchSpecialties handleCardClick={handleCardClick} />
          }
          <NearbyHospitals />
        </div>
        <div className="nex-sidebar v2 col">
          <PeopleKnowWidgetBasisOfLocation />
        </div>
      </div>

    </div>
  )
}
